<template>
    <div class="detailMain" >
        <p class="current">当前位置：<span>{{ currentName }}</span></p>
        
        <div class="Newkeywords">
            <!-- <Menu></Menu> -->
            <!-- <div class="top">
                <img src="../../assets/newLogo.png" alt="">
            </div> -->
            <div class="artcle-right">
                <p class="title">{{ articleInfo.title }}</p>
                <div class="artcle-title-time">
                    <p class="time">发布时间：&nbsp;&nbsp;{{ articleInfo.create_time }}</p>
                    <div class="iconI">
                        <div :class="favActive == 1? 'favActiveClass':''" @click="getActive(item)">
                            <i class="el-icon-star-off" ></i>收藏
                        </div>
                        <div @click="handleSession()">
                            <i class="el-icon-user"></i>咨询
                        </div>
                        <!-- <div >
                            <i class="el-icon-share"></i>分享
                        </div> -->
                        <!-- <div v-show="IsShare">
                            <share :config="config" style="margin-top: 550px;"></share>
                        </div> -->
                       <div style="margin: 0 0;">
                            <el-dropdown @command="HandleCommand">
                                <span>
                                    <i class="el-icon-share"></i>
                                    分享<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <div style="padding: 10px 20px;">
                                        <share :config="config"></share>
                                    </div>
                                    <!-- <el-dropdown-item command="1">微信</el-dropdown-item>
                                    <el-dropdown-item command="2">微博</el-dropdown-item>
                                    <el-dropdown-item command="3">QQ</el-dropdown-item>
                                    <el-dropdown-item command="4">QQ空间</el-dropdown-item> -->
                                </el-dropdown-menu>
                            </el-dropdown>
                       </div>
                    </div>
                </div>
                <div v-show="channelType == 'law'">  
                    <!-- <cTypeLaw :detailDate="articleInfo"></cTypeLaw> -->
                    <div v-if="isIntro != ''">
                        <div v-html="articleInfo.intro" class="intrDiv"></div>
                        <div @click="downloadPDF" v-if="articleInfo.resource_items !='' || fileType == 'pdf'"  style="display: flex;justify-content: flex-start;align-items: center;color: #666666; cursor: pointer;">

                            <img width="80px" height="80px" src="../../assets/pdf.png" alt="">
                            <span>{{ articleInfo.title }}.pdf</span>
                        </div>
                    </div>
                    <div v-else>
                        <iframe 
                            v-if="articleInfo.resource_items !='' || fileType == 'pdf'" 
                            :src="articleInfo.resource_items[0].FileUrl" 
                            height="1800px" width="100%" frameborder="0"></iframe>
                    </div>
                   
                    <div ref="fileDocx"></div>

                </div>
                <div v-show="channelType != 'law'" class="intor-main">
                <!-- <div ref="contentContainer" class="intrDiv"></div> -->
                <div v-html="articleInfo.intro" class="intrDiv"></div>
                <p v-show="IsAddFrom">来源：{{ articleInfo.add_from}}</p>
                <p v-show="IsAuthor">作者：{{ articleInfo.author }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Menu from "../menu/list.vue" 
import cTypeLaw from "./cTypeLaw.vue"
import pdf from "pdfjs-dist"
import { renderAsync } from 'docx-preview'
import { toQQzone, toQQ, toWeibo, toWechat } from '../../excel/share.js'
// import Docx from 'docx'
export default{
    data(){
        return{
            articleInfo: {},
            channelType: '',
            IsAddFrom: '',//判断是否存在来源的字段
            IsAuthor: '',//判断是否存在作者的字段
            currentName:'',
            fileType: '',
            favActive: 0,
            Id: '',
            IsShare: false,
            config:{
                sites: ['qq','wechat','weibo'],
                url: '',
                title: '',
                wechatQrcodeTitle   : '微信扫一扫：分享',
                wechatQrcodeHelper  : '<p>扫一扫</p><p>二维码便可将本文分享至朋友圈。</p>'
            },
            isIntro: ''
        }
    },
    components: {
        Menu,
        pdf,
        cTypeLaw,
    },
    methods: {
        downloadPDF() {
            const { href } = this.$router.resolve({
                path: "/preview",
                query: {
                   id: this.articleInfo.resource_items[0].FileUrl
                }
            });
            window.open(href, '_blank');
            
        },
        handleSession(){
            if(this.currentName == '法律法规'){
                let id = this.articleInfo.recommendIds
                this.$router.push({
                    path: '/expert',
                    query: {
                        channel: 'company'
                    }
                })
                sessionStorage.setItem('lawId',id)
            }else{
                this.$router.push({
                    path: '/session',
                })
            }
           
        },
        formatRichText (html, conWidth) {
            // 去掉img标签里的style、width、height属性
            let newContent= html.replace(/<img[^>]*>/gi,function(match,capture){
                match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
                match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
                match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
                return match;
            });
            
            // 去掉video标签里的style、width、height属性
            newContent= html.replace(/<video[^>]*>/gi,function(match,capture){
                match = match.replace(/style="[^"]+"/gi, '').replace(/style='[^']+'/gi, '');
                match = match.replace(/width="[^"]+"/gi, '').replace(/width='[^']+'/gi, '');
                match = match.replace(/height="[^"]+"/gi, '').replace(/height='[^']+'/gi, '');
                return match;
            });
            
            // 修改所有style里的width属性为max-width:100%
            // 去掉所有style里的font-size属性
            newContent = newContent.replace(/style="[^"]+"/gi,function(match,capture){
                match = match.replace(/width:[^;]+;/gi, 'max-width:100%;').replace(/width:[^;]+;/gi, 'max-width:100%;');
                //match = match.replace(/font-size:[^;]+;/gi, '');
                //match = match.replace(/text-indent:[^;]+;/gi, '');
                return match;
            });
            // 去掉<br/>标签
            newContent = newContent.replace(/<br[^>]*\/>/gi, '');
            // img标签添加style属性：max-width:100%;height:auto
            newContent = newContent.replace(/\<img/gi, '<img style="max-width:100%;height:auto;display:block;margin:0px auto;"');
            //newContent = newContent.replace(/\<img/gi, '<img style="width:'+ conWidth +'px;height:auto;display:block;margin:0px auto;"');
            //newContent = newContent.replace(/\<img/gi, '<img style="width:100%;height:auto;display:block;margin:0px auto;"');
            // video标签添加style属性：max-width:100%;height:auto
            newContent = newContent.replace(/\<video/gi, '<video style="max-width:100%;height:auto;display:block;margin:0px auto;"');
            return newContent;
        },
        infoFavN(data){
            this.$store.dispatch('personal/InfoFavActive',data)
                .then(res => {
                    if(res.ok){
                        this.favActive = 1
                        this.Id = res.data.id
                    }else{
                        this.favActive =-1
                    }
                })
        },
       
        getActive(item){
            if(this.favActive == 1){ //目前收藏状态 点击取消收藏
                let data = {
                    b_type:"article",
                    id: this.Id,
                    xid: this.$route.query.key
                }

                this.$store.dispatch('personal/deleteByUserFav',data)
                    .then(res => {
                        if(res.ok){
                            this.favActive = -1
                            this.$notify({
                                title: '提示',
                                message: '取消成功',
                                type: 'success'
                            })
                        }
                    })
            }else if(this.favActive == -1){
                let data = {
                    b_type:"article",
                    xid: this.$route.query.key
                }

                this.$store.dispatch('personal/addByUserFav',data)
                    .then(res => {
                        if(res.ok){
                            this.favActive = 1
                            this.$notify({
                                title: '提示',
                                message: '收藏成功',
                                type: 'success'
                            })
                        }else if(res.code == -1 && res.msg == '未登录或超时'){
                            this.$notify({
                                title: '提示',
                                message: '未登录或超时，请重新登陆',
                                type: 'error'
                            })
                            this.$router.push('/login')
                            
                        }
                    })
            }
        },
        getSimpleText(html){
            var re1 = new RegExp("<.+?>","g");
            var msg = html.replace(re1,'');
            return msg;
        },
        articleInfoList(data){
            this.$store.dispatch('menu/articleinfo',data)
                .then(res => {
                    let infoFav = {
                        xid: this.$route.query.key,
                        b_type: 'article'
                    }
                    this.infoFavN(infoFav)
                    this.articleInfo = res.data
                    this.channelType = res.data.channel
                    if(this.channelType == 'law'){
                        this.config.url = 'http://h5.qlg360.com/#/pages/article/detailPDF?id=' + this.$route.query.key
                    }else{
                        this.config.url = 'http://h5.qlg360.com/#/pages/article/detail?id=' + this.$route.query.key
                    }

                    this.config.title = this.articleInfo.title
                    if(this.articleInfo.intro != ''){
                        this.articleInfo.intro = this.formatRichText(this.articleInfo.intro)
                        this.isIntro = this.getSimpleText(this.articleInfo.intro)
                    }
                    
                
                    const timeDate = new Date(this.articleInfo.create_time)
                    
                    this.articleInfo.create_time = this.getDateTime(timeDate);

                    if(this.articleInfo.resource_items !=''){
                    let type = this.articleInfo.resource_items[0].FileName.substring(this.articleInfo.resource_items[0].FileName.lastIndexOf(".")) 
                 
                    if(type == '.pdf'){
                            this.fileType = 'pdf'
                    }else if(type == '.docx'){
                            this.fileType = 'docx'
                    }
                    }
                })
        },
        getDateTime(timeDate) {
            const year = timeDate.getFullYear()
            const month = (timeDate.getMonth() + 1).toString().padStart(2, '0')
            const day = timeDate.getDate().toString().padStart(2, '0')
            const hours = timeDate.getHours().toString().padStart(2, '0')
            const minutes = timeDate.getMinutes().toString().padStart(2, '0')
            const seconds = timeDate.getSeconds().toString().padStart(2, '0')
            // const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
            const formattedDate = year+'-'+month+'-'+day+' '+hours+':'+minutes+":"+seconds

            return formattedDate
        },
        handleShare(){
            const url = window.location.href
            console.log(url);
            toQQzone(url, this.articleInfo.title);
            // toQQ(url, this.articleInfo.title);
            // toWeibo(url, this.articleInfo.title);
            // toWechat(url, this.articleInfo.title);
        },
        HandleCommand(val){
          
           
            let url = this.$route.query.key

            if(this.channelType == 'law'){ //法律法规
                url = 'http://h5.qlg360.com/#/pages/article/detailPDF?id='+ url
            }else{
                url = 'http://h5.qlg360.com/#/pages/article/detail?id='+ url
            }
            console.log(url);
            if(val == 1){
                toWechat(url, this.articleInfo.title);
            }else if(val == 2){
                toWeibo(url, this.articleInfo.title);
            }else if(val == 3){
                toQQ(url, this.articleInfo.title);
            }else if(val == 4){
                toQQzone(url, this.articleInfo.title);
            }

        },
        
    },
    created(){
        const data = {
            id: this.$route.query.key
        }
        this.currentName = this.$route.query.currentName
        this.articleInfoList(data)

        
                

           
    }
}


</script>



<style scoped>
@import url(../../css/detailPages.css);
@import url(../../css/detailPages540.css);
</style>